import React from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { deleteResume } from 'api/users';
import { useAuth } from 'hooks/useAuthContext';

const LeaveWithoutUpdatingDialog = ({ updateResume, resumeId, handleClose, isCreateResume }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { jobData } = location.state || { data: null, totalResume: 0, tab: '4', jobData: null, createNewResume: false };
  const [loading] = useState(false);
  const [isProceeding, setIsProceeding] = useState(false);
  const { jobApply } = useAuth();

  /**
   * Proceeds with deleting the resume.
   * Sets the isProceeding state to true and calls the deleteResume function
   * with the given resumeId. After the deletion is done, navigates to the
   * home page with the current tab and job data, and sets the isProceeding
   * state to false.
   */
  const handleProceed = async () => {
    setIsProceeding(true);

    try {
      let state = { tab: "4", data: jobData || null };

      if (isCreateResume) {
        const { success } = await deleteResume({ id: resumeId });

        console[success ? "log" : "error"](
          success ? "Resume deleted" : "Error deleting resume"
        );
      } else {
        state.resumeId = resumeId;
      }

      if (jobApply?.openChatBot) navigate('/home');
      else navigate('/home', { state });

    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setIsProceeding(false);
    }
  };

  return (
    <Box className="ext-job-dialog-wraper remove-job-dialog" sx={{ padding: '24px 20px' }}>
      <Stack justifyContent={'center'}>
        <Box sx={{ textAlign: 'center' }} mb={4}>
          {isCreateResume ? <Typography className="title" mb={0.5}>All changes will be lost, and your new resume will not be created</Typography>
            : <Typography className="title" mb={0.5}>All changes will be lost and your new resume will not be updated</Typography>
          }
        </Box>
        <Stack direction={{ xs: 'column', md: 'row' }} alignItems={'center'} spacing={2.5}>
          <Button fullWidth variant="outlined" size="medium" disableRipple disableElevation onClick={handleClose} disabled={loading}>Cancel</Button>
          <Button className="continue-btn" fullWidth variant="contained" size="medium" disableRipple disableElevation disabled={isProceeding} onClick={handleProceed}>{isProceeding ? 'Proceeding...' : 'Proceed'}</Button>
        </Stack>
      </Stack>
    </Box>
  )
}

export default LeaveWithoutUpdatingDialog
